<template>
  <div class="ma-4">
   <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>
   <StaffNav/>
   <v-row dense>
    <v-col cols="12" lg="3" xl="2">
      <StaffSide />
    </v-col>
    <v-col cols="12" lg="9" xl="10">
      <v-card class="pa-2" outlined tile height="100%">
    <v-data-table
      :headers="headers"
      :items="logs"
      sort-by="Date"
      sort-desc
      :loading="isLoading"
      loading-text="Loading Communication Logs"
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Communication Logs</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            clearable
            flat
            solo-inverted
            hide-details
            prepend-inner-icon="search"
            label="search"
            class="desktop"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="100%">
            <template v-slot:activator="{ on }">
              <v-btn color="#2b3990" dark class="mb-2" v-on="on" @click="showAdd()"
                >
                <v-icon left>add</v-icon>
                Add Log</v-btn
              >
            </template>
          </v-dialog>
        </v-toolbar>
        <v-text-field
          v-model="search"
          clearable
          flat
          solo-inverted
          hide-details
          prepend-inner-icon="search"
          label="search"
          class="mobile ml-5 mr-5 mb-3 mt-3"
        ></v-text-field>
      </template>

     <template v-slot:item.actions="{ item }">
        <span v-if="item.documents != null">
            <v-icon small class="mr-2" @click="downloadDocument(item)">
                mdi-download
            </v-icon>
        </span>

        <v-icon small class="mr-2" @click="viewCommunication(item)">
          mdi-eye
        </v-icon>
        
        <v-icon small @click="deleteCommunication(item)" v-if="admin">
          mdi-delete
        </v-icon>
        
      </template>
      <template v-slot:no-data>
        <v-btn color="#2b3990" class="white--text" @click="getCommunications()">Reset</v-btn>
      </template>
    </v-data-table>
      </v-card>
    </v-col>
    </v-row>
    <Foot/>
  </div>
</template>

<script>
import axios from 'axios'
import StaffNav from '@/components/StaffNav'
import StaffSide from '@/components/StaffSide'
import Foot from '@/components/Footer'
// import moment from 'moment'

const url = require("../client_config/config").url;

export default {
  components: {
      StaffNav,
      StaffSide,
      Foot,
  },
  data: function() {
    return {
      headers: [
        {
          text: 'Date',
          align: 'start',
          sortable: false,
          value: 'Date',
        },
        { text: "Time", value: "Time" },
        { text: "Note Type", value: "NoteType" },
        { text: "Notes", value: "Notes" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      admin: false,
      dialog: false,
      editLog: false,
      newLog: false,
      msg: false,
      menu: false,
      signed: false,
      search: "",
      text:"",
      logs: [],
      isLoading: false,
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      notes: ["Admissions",
        "AMA",
        "Clinical Team Meeting",
        "Dietitian",
        "Discharge",
        "Education",
        "Family Therapy",
        "General",
        "Group Therapy",
        "Nursing",
        "Phase Coordinator",
        "Progress",
        "Recreational Therapy",
        "Relapse",
        "Residential Advisor",
        "Services",
        "Staff Shift Change",
        "Utilization Review",
        "Warnings",
        "Other"],
      commType: ["Family",
        "Legal",
        "Referent",
        "Other"],
      newDate: "",
      time: "",
      contacted: "",
      specify: "",
      noteType: "",
      communicationNotes: "",
      communicationType: "",
      createdBy: localStorage.getItem('Name'),
      staffID: "",
      communicationID: "",
      titleForm: "",
      newDocument: [],
      uploadFile: "",
      newCommunicationLogVideo: "",
      communicationLogVideos: [],
      selectedCommunicationLog: {},
      wavesurfer: null,
      selectedFile: null,
      showAudioFile: "",
      
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.staffID = this.$route.params.employeeID
    this.getCommunications();
    if(localStorage.getItem('userRole') == 'Administration'){
        this.admin = true;
    }
  },

  methods: {
     viewCommunication(item) {
      this.$router.push({ name: 'StaffCommunicationForm', params: { employeeID: this.staffID, action: 'view', communicationID: item._id } });  
    },
    getCommunications: function() {
      this.isLoading = true;
      axios.get(`${url}/staffCommunications/${this.staffID}`).then(res => {
          this.logs = res.data.communication;
      }).finally(() => this.isLoading = false);
    },

    showAdd() {
      this.$router.push({ name: 'StaffCommunicationForm', params: { employeeID: this.staffID, action: 'add' } });
    },

    deleteCommunication(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this communication log?") &&
      this.communicationDelete(id);
    },

    communicationDelete(id) {
      axios.delete(`${url}/staffCommunications/${id}`)
      .then((response) => {
          this.getCommunications();
          if (response.status == 400) {
          response.json().then(function(data) {
              return data.msg;
          });
          }
          this.msg=true;
          this.text="The communication log has been deleted successfully.";
      });
    },

        downloadDocument(item) {
          if (item.documents && item.documents.length > 0) {
            for (let i = 0; i < item.documents.length; i++) {
              let document = item.documents[i];
              let documentName = document.Name || '';
              let documentLink = document.AWSLink || '';
              let FileSaver = require('file-saver');
              FileSaver.saveAs(documentLink, documentName);
            }
          }
        },
  },

};
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
      display: none;
    }
  }

  @media only screen and (max-width: 600px) {
    .desktop {
      display: none;
    }

  }
</style>